<template>
    <section class="primaryInfo">
        <a name="home" style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"></a>
        <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
       
        <section class="information">
            <section class="innerBox">
                <!-- <NewsMenu :isActive="isActive"></NewsMenu> -->
                <!-- <div class="leftMenu">
                    <li @click="gotoHandle(leftItem.anchorId)"
                        :class="['menu-item',isActive === leftItem.anchorId?'menu-item--active':'']"
                        v-for="(leftItem,idx) in leftMenus" :key="idx">
                        {{leftItem.title}}
                    </li>
                </div>  -->
                <NewsMenu :isActive="isActive"></NewsMenu>
                <NewsBar></NewsBar> 
                <div class="info">

                    
                    <h1>PayBy is now live on ToTok in the UAE</h1>
                    
                        <span class="sub_date">March 23, 2020</span>
</br></br>
<p>
    We are always looking for new ways to improve your ToTok experience, which is why we are pleased to bring you our newest feature: PayBy on ToTok.
</p>
<p>
    PayBy enables all our users in the UAE to seamlessly send money to their friends and family from their ToTok chat, as well as to make payments through a QR-code contactless system.
</p>
<p>
    PayBy uses cutting-edge technology to provide a seamless user experience and security for every transaction. The new feature uses global tokenisation technology to securely encrypt and store user financial information, while an AI-based fraud management system has been developed to detect any unauthorized activity.
</p>
<p>
    Perhaps most importantly, given the current global coronavirus pandemic, the new feature creates a contactless and more hygienic way to make payments, which we hope will help our users to stay healthy in the challenging times we are currently experiencing.
</p>
<p>
    To activate PayBy on ToTok, Android smartphone users in the UAE should update to the latest version of ToTok.
</p>
<p>
    Currently, PayBy on ToTok is available exclusively to users in the UAE, but we are working to make the new feature available to our users around the world.
</p>
<h2>
    Introducing PayBy on ToTok
</h2>
<ul>
     <h4 style="
    font-size: 18px;
    margin-bottom: 20px;">Transfer to your friend</h4>
    <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/Transfer-VideoCover.png"
        >
         <source src="https://static.totok.ai/video/PayBy_ToTok_Transfer.mp4" />
        </video>
     <h4 style="
    font-size: 18px;
    margin-bottom: 20px;">Cash Gift</h4>
    <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            poster
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/CashGift-VideoCover.png"
        >
         <source src="https://static.totok.ai/video/PayBy_ToTok_CashGift.mp4" />
        </video>
    
</ul>


<p>Wish you and your loved ones a healthy and happy 2020!</p> </p>

<p>Sent with Love,
<br/>Team ToTok</p></p>


                </div>
                <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
            </section>
        </section>
        <Footer></Footer>
     <FootBanner ></FootBanner>
    </section>
</template>

<script>
import NavCrumbs from '@/components/NavCrumbs.vue'
import NewsBar from '@/components/NewsBar.vue'
import NewsMenu from '@/components/NewsMenu.vue'
import FootBanner from '@/components/FootBanner.vue'
import Footer from '@/components/Footer.vue'

    export default {
        metaInfo() {
            return {
                title: 'PayBy is now live on ToTok in the UAE',
                // meta: [{
                //     vmid: 'og:title',
                //     property: 'og:title',
                //     name: 'og:title',
                //     content: 'Terms of Use - ToTok Messenger',
                // },{
                //     vmid:"og:description",
                //     property: 'og:description',
                //     name: 'og:description',
                //     content: 'Enjoy FREE, FAST and FUN calling with your family and friends.'
                // },]
                meta: [
                    {property: 'og:title', content: 'PayBy is now live on ToTok in the UAE'},
                    {property:  'og:description', content: 'PayBy is now live on ToTok in the UAE'},
                    {property: 'og:url', content: 'https://totok.ai/news-mar23-2020'},
                    {property: 'og:type', content: 'website'},
                    {property: 'og:image', content: 'https://static.totok.ai/pic/preview/free_unblocked_call.png'},
                    {property: 'og:site_name', content: 'ToTok'}
                ]
            }
        },
        components: {
            NewsBar,
            NavCrumbs,
            NewsMenu,
             Footer,
            FootBanner
        },
        data() {
            return {
                showinfo: false,
                isActive: 'newsMar202023',
                crumbProp:{
                    label:"Recent News", 
                    type:"simple"
                },
                leftMenus: [
                    {
                        title: 'Mar 23',
                        anchorId: "newsMar202023"
                    },
                    {
                        title: 'Mar 11',
                        anchorId: "newsMar202011"
                    },
                    {
                        title: 'Mar 05',
                        anchorId: "newsMar202005"
                    },
                    {
                        title: 'Feb 23',
                        anchorId: "newsFeb20200223"
                    },
                    {
                        title: 'Feb 20',
                        anchorId: "Feb202020"
                    },
                    {
                        title: 'Jan 05',
                        anchorId: "Jan05"
                    },
                    {
                        title: 'Dec 29',
                        anchorId: "Dec29"
                    },
                    {
                        title: 'Dec 27',
                        anchorId: "Dec27"
                    },
                    {
                        title: 'Dec 24',
                        anchorId: "Dec24"
                    },
                    {
                        title: 'Dec 23',
                        anchorId: "Dec23"
                    }
                ]
            };
        },
        computed: {
            info() {
                return []
            },
            isPc(){
                 return document.body.offsetWidth > 450; 
            },isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
        },
        methods: {
            gotoHandle(palice) {
                console.log('palice',palice)
                switch (palice) {
                    case "newsMar202023":
                        this.isActive = 'newsMar202023'
                        this.$router.push({name:'newsMar202023'})
                        break;
                    case "newsMar202011":
                        this.isActive = 'newsMar202011'
                        this.$router.push({name:'newsMar202011'})
                        break;
                    case "newsMar202005":
                        this.isActive = 'newsMar202005'
                        this.$router.push({name:'newsMar202005'})
                        break;
                    case "newsFeb20200223":
                        this.isActive = 'newsFeb20200223'
                        this.$router.push({name:'newsFeb20200223'})
                        break;
                    case "Feb202020":
                        this.isActive = 'Feb202020'
                        this.$router.push({name:'newsFeb202020'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Jan05":
                        this.isActive = 'Jan05'
                        this.$router.push({name:'newsJan05'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec29":
                        this.isActive = 'Dec29'
                        this.$router.push({name:'newsDec29'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec27":
                        this.isActive = 'Dec27'
                        this.$router.push({name:'newsDec27'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec24":
                        this.isActive = 'Dec24'
                        this.$router.push({name:'newsDec24'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                     case "Dec23":
                        this.isActive = 'Dec23'
                        // this.$router.push({name:'newsDec22'})
                        // this.mainPannel.scrollTo(0, 0)
                        this.$router.push({name:'newsDec22'})
                        break;
                    
                }
            }
        }
    }
</script>
<style scoped lang="stylus">
      @media only screen and (max-width: 700px) {
        .primaryInfo {
            // padding: 0.8rem;
            background: #fff;
            height: 106vh;
            .innerBox {
                padding-bottom: 50px; 
            }
            .leftMenu {
                display none
            }

            div {
                margin-left: 20px;
                margin-right: 20px;
            }

            .info {


                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 40px;
                    margin: 0px;
                    line-height: 40px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    // margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    // margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 3.5rem;
            font-size: 13px;
            color: #808080;
            line-height: 3.5rem;
            text-align: center;
        }
    }

    @media only screen and (min-width: 701px) {
        .primaryInfo {
            padding-top: 102px;
            width: 100vw;
            background: #fff;

            .information {
                margin: 0 auto;
                width: 800px;

                .innerBox {
                    position relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-end;
                    height: 83vh;
                    overflow: auto;
                        

                    .leftMenu {
                        position: absolute;
                        left: 0px;
                        top: 39px;
                        display flex;
                        flex-direction column;
                        justify-content center;
                        align-items: flex-start;
                        list-style none;

                        .menu-item {
                            color: #979797;
                            margin-top: 30px;
                            cursor pointer;
                            text-decoration none;
                            font-size: 15px;
                        }

                        .menu-item:nth-child(1) {
                            margin-top: 0px;
                        }

                        .menu-item--active {
                            color: #000;
                            border-bottom: 2px solid #4377f2;
                        }

                    }
                }
            }

            .info {
                width: 550px;
                margin: 20px 0;
margin-bottom:60px;
                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 20px;
                    margin: 0px;
                    line-height: 40px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 70px; 
            font-size: 13px;
            color: #808080;
            line-height: 70px;
            text-align: center;
        }
    }
</style>